import { render } from "./View5.vue?vue&type=template&id=45d8b650"
import script from "./View5.vue?vue&type=script&lang=js"
export * from "./View5.vue?vue&type=script&lang=js"

import "./View5.vue?vue&type=style&index=0&id=45d8b650&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__